import React from "react";
import PageHero from "../components/PageHero";
import Services from "../components/Services";
import EnergyEstimator from "../components/EnergyEstimator";
import FinalCTA from "../components/FinalCTA";

export default function ServicesPage() {
  return (
    <>
      <PageHero
        eyebrow="Our Products & Solutions"
        title={["SOLAR PRODUCTS", "FOR EVERY", "KIND OF SITE."]}
        subtitle="From rooftop on-grid systems to battery monitoring — every product we offer, in one place."
      />
      <Services />
      <EnergyEstimator />
      <FinalCTA />
    </>
  );
}
